import React from 'react';
import UserAgreementModal from '../../UserAgreementModal';
import { AdminTopBar } from './AdminTopBar';
import { AdminNavSideMenu } from './AdminNavSideMenu';
import { SidebarProvider, SidebarContent } from '@ka/webcomponents/nav';

const AdminPortalLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return <SidebarProvider>
    <UserAgreementModal />
    <AdminTopBar />
    <main id="content" role="main" className="navbar-sidebar-aside navbar-sidebar-aside-sm portal-content">
      <AdminNavSideMenu />
      <SidebarContent className="content-space-t-1 content-space-b-2 px-lg-5 px-xl-10 portal-content-body d-flex flex-column">
        {children}
      </SidebarContent>
    </main>
  </SidebarProvider>;
}

export { AdminPortalLayout };
